<template>
  <div class="beauty-tags-wrapper">
    <ul class="beauty-tags">
      <li v-for="(subtag, index) in beautyTags.slice(0, 5)" :key="index">
        <img class="tag-image" :src="subtag.image" :alt="subtag.name" height="14" width="14" />
        <span class="tag-name">{{ subtag.name }}</span>
        <span v-if="index < beautyTags.slice(0, 5).length - 1" class="separator">&#183;</span>
      </li>
      <v-popover v-if="beautyTags.length > 5" placement="bottom-end" offset="5" class="more-review">
        <!-- This will be the popover target (for the events and position) -->
        &nbsp;<span class="tooltip-target reviews-more">+more</span>
        <!-- This will be the content of the popover -->
        <template slot="popover">
          <p
            v-for="(subtag, key) in beautyTags.slice(5, beautyTags.length)"
            :key="`popover-${key}`"
          >
            {{ subtag.name.replace(/\,/g, '') }}
          </p>
        </template>
      </v-popover>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'UserBeautyTags',
  props: {
    product: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  computed: {
    beautyProfile() {
      return this.$store.state.auth.userProfile.beauty;
    },
    beautyTags() {
      const {
        beautyProfile: tags,
        product: { categories },
      } = this;
      const productCategory = (categories && categories[0]) || {};
      const findCategoryByName = (name) => {
        return Boolean(categories && categories.length && categories.find(category => category.name === name));
      };
      let tagList = [];

      if (productCategory && productCategory.name) {
        const tagsItem = [];
        if (productCategory.name !== 'Hair Care') {
          tagsItem.push('jenis-kulit');
          if (productCategory.name === 'Makeup') {
            tagsItem.push('undertone');
            tagsItem.push('warna-kulit');
          } else if (findCategoryByName('Skincare') || findCategoryByName('Accessories') || findCategoryByName('Bath & Body')) {
            tagsItem.push('kondisi-kulit');
          }
        } else {
          tagsItem.push('kondisi-rambut');
          tagsItem.push('jenis-rambut');
        }
        tagList = (tags || []).filter((res) => {
          return tagsItem.includes(res.name);
        });
      }

      return tagList.length
        ? tagList.reduce((previous, current) => {
            return previous.concat(current.subtags);
          }, [])
        : [];
    },
  }
}
</script>

<style lang="scss" scoped>
  .beauty-tags {
    p {
      font-family: $lato_regular;
      font-size: 12px;
      color: #222222;
      letter-spacing: 0;
      line-height: 20px;
      margin-bottom: 6px;
    }
    display: flex;
    align-items: center;
    margin-bottom: 0;
    @media (max-width: 991px) {
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    li {
      &:not(:last-of-type) {
        margin-right: 8px;
      }
      display: flex;
      align-items: center;
      min-width: max-content;
      .tag-image {
        object-fit: contain;
      }
      .tag-name {
        margin-left: 4px;
        margin-right: 8px;
        font-family: $lato_regular;
        font-size: 11px;
        color: #222222;
        text-align: left;
        line-height: 16px;
      }
    }
    .more-review {
      font-family: $lato_regular;
      font-size: 11px;
      color: #f384a7;
      text-align: left;
      line-height: 16px;
      cursor: pointer;
    }
  }
</style>